import { css } from '@emotion/react'
import { Text, VFlow } from 'bold-ui'
import { PageContent } from 'components/layout/PageContent'
import { LoadingIndicator } from 'components/loading'

interface SemFamiliaContainerProps {
  loading: boolean
  cidadaoMudouSe: boolean
  semFamilia: boolean
}

export const SemFamiliaContainer = (props: SemFamiliaContainerProps) => {
  const { cidadaoMudouSe, semFamilia, loading } = props

  const getContent = () => {
    if (loading) {
      return <LoadingIndicator />
    }

    if (cidadaoMudouSe) {
      return (
        <Text fontWeight='bold'>
          Este cidadão não está mais vinculado ao território e, por isso, não possui família cadastrada.
        </Text>
      )
    }

    if (semFamilia) {
      return (
        <VFlow>
          <Text fontWeight='bold'>Este cidadão ainda não está cadastrado em uma família.</Text>
          <Text fontStyle='italic'>Você pode realizar essa atualização através do Acompanhamento do território.</Text>
        </VFlow>
      )
    }
  }

  return (
    <PageContent
      type='filled'
      style={css`
        text-align: center;
      `}
    >
      {getContent()}
    </PageContent>
  )
}
